import React, { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import { useApi, useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { useSettings } from '../../context/SettingsContext';
import { FileDown, Eye } from 'lucide-react';

function RaportVleraStok() {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [error, setError] = useState('');

  const { data, loading, execute: loadData } = useApi(
    () => apiService.get('/raport-vlera-stok'),
    [],
    { immediate: true, showNotifications: false }
  );

  const handleExportPdf = async () => {
    try {
      const response = await apiService.get('/raport-vlera-stok/pdf', {
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      window.open(URL.createObjectURL(file));
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Deshtoi shkarkimi i PDF-it.');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Raport Vlera Stok</h2>

      <div className="flex gap-2">
        <button
          onClick={loadData}
          className="btn-premium flex items-center gap-2"
        >
          <Eye size={18} /> Rifresko
        </button>
        <button
          onClick={handleExportPdf}
          className="btn-premium flex items-center gap-2"
        >
          <FileDown size={18} /> Shkarko PDF
        </button>
      </div>

      {error && <p className="p-3 rounded-lg bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-300 font-medium">{error}</p>}

      {loading && <p className="text-gray-500 dark:text-gray-400">Duke ngarkuar...</p>}

      {data && (
        <div className="space-y-8">
          <div className="card-premium p-4 font-semibold text-gray-800 dark:text-gray-100 text-lg">
            Totali: <span className="text-primary-600 dark:text-primary-400">{Number(data.totali || 0).toFixed(2)} {currencyCode}</span>
          </div>

          {Object.entries(data.lokacionet || {}).map(([lokacioni, lista]) => (
            <div key={lokacioni} className="space-y-3">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Lokacioni: {lokacioni}</h3>
              <div className="card-premium overflow-x-auto p-0">
                <table className="table-premium">
                  <thead>
                    <tr>
                      <th>Produkti</th>
                      <th>Madhesia</th>
                      <th>Ngjyra</th>
                      <th className="text-right">Sasia</th>
                      <th className="text-right">Cmimi Blerjes</th>
                      <th className="text-right">Vlera</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((r, i) => (
                      <tr key={i}>
                        <td className="font-medium">{r.produkti}</td>
                        <td>{r.madhesia}</td>
                        <td>{r.ngjyra}</td>
                        <td className="text-right">{r.sasia}</td>
                        <td className="text-right">{Number(r.cmimi_blerjes).toFixed(2)} {currencyCode}</td>
                        <td className="text-right font-semibold text-primary-600 dark:text-primary-400">{Number(r.vlera).toFixed(2)} {currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default RaportVleraStok;
